import React from 'react';
import './ArticleComponentCSS/Blockquote.css';

const Blockquote = ({ children }) => {
  return <blockquote>{children}</blockquote>;
};

export default Blockquote;
